import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/lib/LanguageContext";
import { AuthProvider } from "@/lib/AuthContext";
import { TenantProvider } from "@/lib/TenantContext";
import SmoothScroll from "@/lib/SmoothScroll";
import ScrollToHash from "@/lib/ScrollToHash";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/lib/ErrorBoundary";
import TenantSite, { TenantSiteHost } from "@/tenant/TenantSite";
import { platformRoutes } from "@/routes/platformRoutes";
import { adminRoutes } from "@/routes/adminRoutes";
import { superAdminRoutes } from "@/routes/superAdminRoutes";
import { isTenantHost } from "@/lib/tenantHost";
import AffiliateRefCapture from "@/components/AffiliateRefCapture";

const AppRouter = () => {
  // NOTE: the legacy Emergent OAuth hash callback (#session_id=...) is gone — GIS
  // (Google Identity Services) posts the session directly from GoogleLoginButton,
  // no redirect/hash round-trip involved. See lib/GoogleLoginButton.jsx.
  // Phase C: on a tenant host (custom domain or <label>.solunary.health), serve the
  // tenant's public site directly at "/", resolved by Host. The platform/admin routes
  // only apply on platform hosts.
  if (isTenantHost()) {
    return (
      <>
        <ScrollToHash />
        {/* Attribution (contract §2): ONE mount per branch. This branch and the platform
            one below are the only two places that see every URL on their host exactly
            once — `platformRoutes.jsx` is a bare <Route> fragment, and `TenantSite.jsx`
            is rendered by BOTH branches, so a mount there would double every click. */}
        <AffiliateRefCapture />
        <TenantSiteHost />
      </>
    );
  }
  return (
    <>
      <ScrollToHash />
      <AffiliateRefCapture />
      <Routes>
        {platformRoutes}
        {adminRoutes}
        {superAdminRoutes}
        {/* === Sites praticiens (chemin interne /t/{slug} — transitionnel) === */}
        <Route path="/t/:slug/*" element={<TenantSite />} />
      </Routes>
    </>
  );
};

export default function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <TenantProvider slug="emilie">
            <SmoothScroll>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
              <Toaster />
            </SmoothScroll>
          </TenantProvider>
        </AuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}
